import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './interim-agency-settings-wrapper'
import { useTerminalsQuery } from '../../queries/terminals'
import TerminalsList from '../../components/terminals/list'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { Box } from 'react-bulma-components'
import { compareDocsById } from '../../utils/documents'

/**
 * Displays the list of terminals for an interim agency
 */
const TerminalsSettings: React.FC = () => {
  const { interimAgency } = useOutletContext<OutletContext>()
  const { data: terminals } = useTerminalsQuery(
    {
      'usagePeriods.interimAgency': interimAgency?._id,
    },
    {
      enabled: Boolean(interimAgency),
    },
  )

  //TODO: handle that in the backend and remove this filter
  const terminalsForInterimAgency = terminals?.map(terminal => {
    terminal.usagePeriods = terminal.usagePeriods.filter(usagePeriod =>
      compareDocsById(usagePeriod.interimAgency, interimAgency),
    )
    return terminal
  })

  return (
    <>
      <SidebarContentTitle title="Bornes de Pointage" />
      <Box>
        <TerminalsList data={terminalsForInterimAgency || []} />
      </Box>
    </>
  )
}

export default TerminalsSettings
